<div class="mb-5 w-fit rounded-2xl border border-gray-300 bg-gradient-to-r from-gray-50 to-white px-5 py-3">
  <div class="border-l-4 border-gray-800 pl-4">
    <p class="text-xs font-semibold uppercase tracking-[0.18em] text-gray-500">
      Social Company Section
    </p>
    <h2 class="mt-1 text-2xl font-bold tracking-tight text-gray-900">
      Company
    </h2>
  </div>
</div>

<!-- MAIN -->
<div>
  <div class="flex flex-row items-center gap-4 mb-4">
    <button (click)="navigateToCreateAccount()" class="primary-btn">
      Create Account
    </button>
  </div>
  <app-company-table></app-company-table>
</div>

<!-- SIDEBAR -->
<!--
<div class="hidden md:block col-span-12 2xl:col-span-3 px-3 2xl:px-6 mt-6 2xl:mt-0">
  <app-sidebar></app-sidebar>
</div>
-->